module.exports = __webpack_public_path__ + "img/icon_003.a14ae4cd.png";